export const POWER_AC = [3.5, 7.4, 11, 22, 48];

export const POWER_DC = [
  20, 24, 30, 40, 47, 50, 60, 70, 80, 90, 100, 120, 150, 160, 180, 200, 240,
  320, 350, 460, 480, 640, 1500,
];
